export function translateOptionSymbol(symbol) {
  if (typeof symbol !== 'string' || symbol.length === 0) return 'N/A';
  let underlying;
  let optionDetails;
  const regex = /\d/;
  for (let i = 0; i < symbol.length; i++) {
    if (regex.test(symbol[i])) {
      underlying = symbol.slice(0, i);
      optionDetails = symbol.slice(i);
      break;
    }
  }
  if (!underlying || !optionDetails) return symbol;
  let date;
  let strikeDetails;
  for (let i = 0; i < optionDetails.length; i++) {
    if (!regex.test(optionDetails[i])) {
      date = optionDetails.slice(0, i);
      strikeDetails = optionDetails.slice(i);
      break;
    }
  }
  if (!date || !strikeDetails || strikeDetails.length < 2) return symbol;
  const year = date.slice(0, 2);
  const monthAndDay = date.slice(2);
  if (year.length !== 2 || monthAndDay.length < 4) return symbol;
  const formattedYearMonthAndDay = monthAndDay.slice(0, 2) + '-' + monthAndDay.slice(2, 4) + '-' + year;
  const callOrPutt = strikeDetails[0];
  const strike = strikeDetails.slice(1);
  if (!/[CP]/.test(callOrPutt) || strike.length === 0) return symbol;
  const cleanStrike = strike.replace(/^0+/, '');
  const decimals = cleanStrike.slice(cleanStrike.length - 3).replace(/0+$/, '');
  const strikeResult = cleanStrike.slice(0, cleanStrike.length - 3) + (decimals.length > 0 ? '.' + decimals : '');
  return underlying + '.' + formattedYearMonthAndDay + '.' + callOrPutt + '.' + strikeResult;

}

//350000
